module.exports = __webpack_public_path__ + "static/media/SFiOBOA_bm_engl_sekundærlogo_sentrert_logo_pos.68c55d16.pdf";